import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Constants } from 'utils';
import { Table, Pagination, Tooltip, DatePicker, Select, GuideVideoModal } from 'components';
import { CleanIcon, ViewIcon } from 'assets/icons';
import { GuideService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  area_id: '',
  type_id: '',
  date: '',
};

class ClientGuides extends React.Component<Props> {
  state = {
    header: ['Fecha', 'Tipo de derecho', 'Tipo de Guía', 'Contenido', 'Acciones'],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    areas: [],
    types: [],
    visible_video: false,
    selected_video: null as any,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Guías y Tutoriales',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.loadGuides();
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await GuideService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.guides.rows,
      last_page: res.guides.count,
    });
  };

  loadGuides = async () => {
    const res: any = await GuideService.admin.getAreas({
      withoutLoading: true,
    });
    this.setState({
      areas: res.areas || [],
      types: res.types || [],
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  render() {
    return (
      <div id='client-guides'>
        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-3'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Tipo de Guía'
                  name='type_id'
                  onChange={(e: any) =>
                    this.change(
                      {
                        target: {
                          name: 'type_id',
                          value: e.target.value,
                        },
                      },
                      async () => {
                        if (Number(this.state.form.type_id) === Constants.GUIDE_TYPES.YOUTUBE) {
                          this.change({ target: { name: 'area_id', value: '' } }, () =>
                            this.load(true),
                          );
                          return;
                        }

                        this.load(true);
                      },
                    )
                  }
                  value={this.state.form.type_id}
                  options={this.state.types.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className='col-md-3'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Tipo de derecho'
                  name='area_id'
                  disabled={Number(this.state.form.type_id) === Constants.GUIDE_TYPES.YOUTUBE}
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.area_id}
                  options={this.state.areas.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className='col-md-3'>
                <DatePicker
                  label='Fecha'
                  placeholder='Fecha'
                  maxDate={moment().toDate()}
                  onChange={(text: string) => {
                    this.change(
                      {
                        target: {
                          value: text,
                          name: 'date',
                        },
                      },
                      () => this.load(true),
                    );
                  }}
                  value={this.state.form.date}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title='Guías y Tutoriales'
          data={this.state.data.length}
          header={this.state.header}
          rightAlign={[4]}
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{moment(i.created_at).format('DD/MM/YYYY')}</td>
                <td>{i.area?.name || '-'}</td>
                <td>{i.type?.name || '-'}</td>
                <td>{i.type_id === Constants.GUIDE_TYPES.YOUTUBE ? i.name || '-' : 'Archivo'}</td>
                <td className='text-right'>
                  {i.file != null && (
                    <Tooltip title='Ver'>
                      <a
                        className='link-icon'
                        target='_blank'
                        href={Constants.BASE_STORAGE + i.file}
                      >
                        <img src={ViewIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {i.type_id === Constants.GUIDE_TYPES.YOUTUBE && i.youtube_video_id != null && (
                    <Tooltip title='Ver video'>
                      <a
                        className='link-icon'
                        href='#'
                        onClick={(e: any) => {
                          e.preventDefault();
                          this.setState({ visible_video: true, selected_video: i });
                        }}
                      >
                        <img src={ViewIcon} />
                      </a>
                    </Tooltip>
                  )}
                </td>
              </tr>
            );
          })}
        </Table>

        <GuideVideoModal
          visible={this.state.visible_video}
          youtubeVideoId={this.state.selected_video?.youtube_video_id}
          name={this.state.selected_video?.name}
          onClose={() => this.setState({ visible_video: false, selected_video: null })}
        />

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(ClientGuides);
